import { render } from "./cs-image.vue?vue&type=template&id=0fdb754c&scoped=true"
import script from "./cs-image.vue?vue&type=script&lang=js"
export * from "./cs-image.vue?vue&type=script&lang=js"

import "./cs-image.vue?vue&type=style&index=0&id=0fdb754c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0fdb754c"

export default script